module.exports = __webpack_public_path__ + "static/media/Nose.1dacb9ee.ogg";